<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="newObject"
          >
            <i class="fa fa-address-card-o"></i>
            Add Global Filter
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="LPFilter"
          >
            <div slot="header">
              <h2>{{ mySelected.LPFilterName }}</h2>
              <h4>{{ mySelected.LPFilterDesc }}</h4>
            </div>
            <div slot="details">
              <div></div>
            </div>
            <span slot="entityType">Filter</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "LPFilterList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "LPFilterName",
          label: "Filter",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "LPFilterDesc",
          label: "Description",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "MinAge",
          label: "Min Age",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "MaxAge",
          label: "Max Age",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "MinIncome",
          label: "Income",
          sortable: true,
          thStyle: "width: 10%;"
        }
      ],
      mySelected: { LPFilter: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.lpfilter.global_lpfilters.length;
    },
    totalObjects: function() {
      return this.$store.state.seminar.cuisines;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["lpfilter", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalRows(newValue, oldValue) {
      this.filterList();
    }
  },
  methods: {
    async myLoadComponent() {
      await this.$store.dispatch("lpfilter/fetchLPFiltersGlobal");
      this.filterList();
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.lpfilter.global_lpfilters.filter(
        filter =>
          filter.LPFilterName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          filter.LPFilterDesc.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      console.log(record);
      this.$store
        .dispatch("lpfilter/loadLPFilterEdit", record.LPFilterID)
        .then(() => {
          this.$router.push({ name: "Filter" });
        });
    },
    newObject() {
      this.$store
        .dispatch("lpfilter/newGlobalFilter", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Filter" });
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshObject() {
      return {
        LPFilterID: -1,
        OwnerID: -1
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
